import {
    chain,
    LoadRealTimePricingAndInventory as baseLoadRealTimePricingAndInventory,
    PopulateApiParameter as basePopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { createChainHandler, replaceInChain } from "@store/Modules/client-framework/HandlerCreator";

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    basePopulateApiParameter(props as any);
    props.apiParameter.additionalExpands = ["properties"];
});

export const LoadRealTimePricesOnly = createChainHandler("LoadRealTimePricesOnly", chain, props => {
    const productInfosByProductId = props.result.productInfosByProductId || {};
    const productPriceParameters = Object.keys(productInfosByProductId)
        .filter(productId => !productInfosByProductId[productId]?.pricing)
        .map(productId => productInfosByProductId[productId]!);

    if (!productPriceParameters.length) {
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters,
            onSuccess: realTimePricing => {
                props.dispatch({
                    type: "Pages/ProductList/CompleteLoadRealTimePricing",
                    realTimePricing,
                });
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductList/FailedLoadRealTimePricing",
                });
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
});

replaceInChain(chain, basePopulateApiParameter, PopulateApiParameter);
replaceInChain(chain, baseLoadRealTimePricingAndInventory, LoadRealTimePricesOnly);
